import * as React from 'react';
import classnames from 'classnames';
import SwipeableViews from 'react-swipeable-views';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { useInterval } from '@grandvisionhq/utils';

const INTERVAL = 4000;
const Carousel = ({ children , className , autoLoop =false , navigation =true , pagination =true , inverseColor =false , onPrevSlide =undefined , onNextSlide =undefined , 'data-t': dataT ,  })=>{
    const { getLabel  } = useIntl();
    const [activeIndex, setActiveIndex] = React.useState(0);
    const setSlide = React.useCallback((index)=>{
        if (index !== activeIndex) {
            setActiveIndex(index);
        }
    }, [
        activeIndex
    ]);
    const prevSlide = React.useCallback(()=>{
        setActiveIndex((index)=>index !== 0 ? index - 1 : children.length
        );
    }, [
        children.length
    ]);
    const nextSlide = React.useCallback(()=>{
        setActiveIndex((index)=>index !== children.length - 1 ? index + 1 : 0
        );
    }, [
        children.length
    ]);
    const handlePrevClick = React.useCallback((e)=>{
        prevSlide();
        e.preventDefault();
        onPrevSlide && onPrevSlide();
    }, [
        onPrevSlide,
        prevSlide
    ]);
    const handleNextClick = React.useCallback((e)=>{
        nextSlide();
        e.preventDefault();
        onNextSlide && onNextSlide();
    }, [
        nextSlide,
        onNextSlide
    ]);
    useInterval(nextSlide, autoLoop ? INTERVAL : null);
    if (!children || children.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('carousel', className),
        "data-t": dataT || 'carousel'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "carousel__inner"
    }, /*#__PURE__*/ React.createElement(SwipeableViews, {
        style: {
            height: '100%'
        },
        onChangeIndex: setSlide,
        enableMouseEvents: true,
        index: activeIndex
    }, children.map((child, i)=>/*#__PURE__*/ React.createElement("div", {
            className: "carousel__item",
            key: `item-${i}`
        }, child)
    ))), navigation && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: classnames('carousel__navigation-chevron carousel__navigation-chevron--left', {
            disabled: activeIndex < 1,
            inversed: inverseColor
        }),
        disabled: activeIndex < 1,
        onClick: handlePrevClick,
        "aria-label": getLabel('common.actions.previous')
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-left"
    })), /*#__PURE__*/ React.createElement("button", {
        className: classnames('carousel__navigation-chevron carousel__navigation-chevron--right', {
            disabled: activeIndex >= children.length - 1,
            inversed: inverseColor
        }),
        disabled: activeIndex >= children.length - 1,
        onClick: handleNextClick,
        "aria-label": getLabel('common.actions.next')
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right"
    }))), pagination && /*#__PURE__*/ React.createElement("div", {
        className: "carousel__pagination"
    }, children.map((_, index)=>/*#__PURE__*/ React.createElement("button", {
            key: index,
            "aria-label": `${index + 1}`,
            className: classnames('carousel__pagination-indicator', {
                _is_active: index === activeIndex
            }),
            onClick: ()=>setSlide(index)
        })
    )));
};
var Carousel$1 = Carousel;

export { Carousel, INTERVAL, Carousel$1 as default };
//# sourceMappingURL=Carousel.js.map
